import { FunctionComponent } from 'react'
import { ProgressBarProps } from './types'
import { useValidateProgress, useValidateProps } from './utils'
import useStyles from './styles'

export const ProgressBar: FunctionComponent<ProgressBarProps> = ({
  size: sizeProp,
  color,
  progress: propProgress = 0,
  styles: overrides,
  width = '100%',
}) => {
  const { size } = useValidateProps({ size: sizeProp })
  const { progress } = useValidateProgress({ progress: propProgress })
  const styles = useStyles({ size, width, progress, color })

  return (
    <div css={[styles.root, overrides?.root]} data-testid="hero-progressBar">
      <span css={[styles.progress, overrides?.progress]} />
    </div>
  )
}
